import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './index';
import api from '../api/api';

export default configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            thunk: {
                extraArgument: api
            }
        }),
    devTools: process.env.NODE_ENV !== 'production'
});

